import React from "react"
import style from "./BaseLayout.css"
import Div100vh from 'react-div-100vh';

export const BaseLayout = ({children}) => {
    return <Div100vh>
        <div className={style.layout}>{children}</div>
    </Div100vh>
}
